module.exports = __webpack_public_path__ + "static/media/battery_level_1_icon.c76d2d13.svg";